import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NewsAlertModel, getSeverityClass, getSeverityIcon} from '@shared/models/news-alert.model';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent implements OnInit {

  news: NewsAlertModel;

  // Expose helper functions to template
  getSeverityClass = getSeverityClass;
  getSeverityIcon = getSeverityIcon;

  constructor(
    public bsModalRef: BsModalRef
  ) {
  }

  ngOnInit(): void {
  }

}
